import React from 'react';
import './PDPContent.scss';

const PDPContent = ({ image, hideImage = false }) =>
  !hideImage && (
    <div className="c-pdp-content background-color-gray">
      <img src={image.url} alt={image.alt} className="c-pdp-content__image" />
    </div>
  );

export default PDPContent;
